import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CallDirectionBadge.module.css';

interface CallDirectionBadgeProps {
  direction?: string | null;
  className?: string;
}

export function CallDirectionBadge({ direction, className }: CallDirectionBadgeProps) {
  const { t } = useTranslation('call');

  if (!direction) {
    return null;
  }

  const isOutbound = direction.toUpperCase() === 'OUTBOUND';

  return (
    <span
      className={`${styles.badge} ${isOutbound ? styles.outbound : styles.inbound} ${className ?? ''}`}
    >
      {isOutbound ? t('direction.outbound') : t('direction.inbound')}
    </span>
  );
}

export default CallDirectionBadge;
